<script>
import Modal from './Modal.vue'
import axios from 'axios';

export default {
    components: {
        Modal
    },

    props: {
        message: {
            type: String,
            default: 'Are you sure ?'
        },
        timesButton: {
            type: Boolean,
            default: false
        },
        open: {
            type: Boolean,
            default: true
        },
        staticBackdrop: {
            type: Boolean,
            default: true
        }
    },

    data() {
        return {
            cellphone: '',
            errors: []
        }
    },

    methods: {
        update() {
            const thos = this
            const formData = {
                cellphone: this.cellphone,
            }

            axios.post(`/ajax/update-cellphone`, formData).then(function (response) {
                if(response.data.success) {
                    window.location.href = window.location.href
                } else {
                    thos.errors = []
                    for (const [key, value] of Object.entries(response.data.message)) {
                        for (const [errorkey, error] of Object.entries(value)) {
                            thos.errors.push(error)
                        }
                    }
                }
            });
        },
    }
}
</script>

<template>
    <modal ref="modal" heading="Confirmation" :open="open" :times-button="timesButton"
        :static-backdrop="staticBackdrop">
        <div class="text-center f-18" v-html="message">
        </div>
        <div class="grid-x">
            <div class="small-12 medium-offset-3 medium-6 mt-3 f-18">
                <div class="input-group">
                    <input v-model="cellphone" type="text" class="input-group-field" placeholder="Your cellphone number">
                    <div class="input-group-button">
                        <input @click="update" type="button" class="button" value="Submit">
                    </div>
                </div>
                <div v-if="errors.length > 0">
                    <div class="text-danger" v-for="error in errors" :key="error">
                        <small> {{ error }}</small>
                    </div>
                </div>
            </div>
        </div>
    </modal>
</template>

